import React, { useState, useEffect } from "react";
import { Grid, Typography, Card, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import * as Sentry from "@sentry/react";
import useMediaQuery from "@mui/material/useMediaQuery";
import IntroductionFormApi from "../../../../services/api/introductionForm";
import InputField from "../../new/InputField/InputField";
import AutoCompleteDropdown from "../../new/AutoCompleteDropdown/AutoCompleteDropdown";
import { getOptions } from "../../../../utils";
// import Colors from "../../../../theme/colors";
import Button from "../../Button";

function ZoneLocator({ handleClose, handleSelectedOption }) {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [pincode, setPincode] = useState("");
  const [addressPhrases, setAddressPhrases] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);

  const getStates = async () => {
    const response = await IntroductionFormApi.getStates();
    setStates(response.data);
  };

  useEffect(() => {
    getStates();
  }, []);

  const handlePincodeChange = (e) => {
    if (e.target.value) {
      setPincode(e.target.value);
    } else {
      setPincode("");
    }
  };

  const handleAddresPhrasesChange = (e) => {
    if (e.target.value) {
      setAddressPhrases(e.target.value);
    } else {
      setAddressPhrases("");
    }
  };

  const getGeoLocatorData = async (params) => {
    try {
      setIsLoading(true);
      const response = await IntroductionFormApi.getGeoLocator({
        data: params,
      });
      if (response.data) {
        setListData(response.data);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      Sentry.captureException(err);
    }
  };

  const onSearchClick = () => {
    const params = { stateId: selectedState, cityId: selectedCity };
    if (pincode) {
      params.pincode = pincode;
    }
    if (addressPhrases) {
      params.address = addressPhrases;
    }
    getGeoLocatorData(params);
  };

  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Card
      style={{
        position: "absolute",
        top: 100,
        right: isMobile ? 0 : 30,
        borderRadius: 8,
        width: isMobile ? "100%" : "50%",
        border: "1px solid rgba(97, 97, 97, 0.5)",
        zIndex: 999,
        maxHeight: "600px",
        overflowY: "scroll",
      }}
      elevation={5}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        style={{ marginBottom: 30, padding: 20 }}
      >
        <Grid item>
          <Typography style={{ fontSize: 24, color: "#171B5E" }}>
            Zone Locator
          </Typography>
        </Grid>
        <Grid item onClick={handleClose} style={{ cursor: "pointer" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <CloseIcon
              style={{
                fontSize: 18,
                color: "rgba(97, 97, 97, 0.5)",
                marginRight: 5,
              }}
            />
            <Typography
              style={{ fontSize: 16, color: "rgba(97, 97, 97, 0.5)" }}
            >
              Close
            </Typography>
          </div>
        </Grid>
      </Grid>
      <Grid container style={{ padding: 20 }}>
        <Grid item md={12} xs={12}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.stateName}
            label="State"
            name="state"
            options={getOptions(states, "stateId")}
            value={selectedState}
            inputProps={{ required: true }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setSelectedState("");
                setSelectedCity("");
                setCities([]);
              } else {
                setSelectedState(selectedValue.value);
                setCities(selectedValue.cities);
              }
            }}
          />
        </Grid>
        <Grid item md={12} xs={12} style={{ marginTop: 10 }}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.cityName}
            label="City"
            name="city"
            options={getOptions(cities, "cityId")}
            value={selectedCity}
            disabled={!selectedState}
            inputProps={{ required: true }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setSelectedCity("");
              } else {
                setSelectedCity(selectedValue.value);
              }
            }}
          />
        </Grid>
        <Grid item md={12} xs={12} style={{ marginTop: 10 }}>
          <InputField
            label="Pincode"
            name="pincode"
            style={{ width: "100%" }}
            onChange={handlePincodeChange}
          />
        </Grid>
        <Grid item md={12} xs={12} style={{ marginTop: 10 }}>
          <InputField
            label="Address Phrases"
            name="addressPhrases"
            style={{ width: "100%" }}
            onChange={handleAddresPhrasesChange}
          />
        </Grid>
        <Button
          variant="contained"
          disabled={!(selectedCity && selectedState) || isLoading}
          onClick={onSearchClick}
          style={{
            marginTop: "20px",
            opacity: !(selectedCity && selectedState) || isLoading ? ".5" : {},
            pointerEvents: !(selectedCity && selectedState) ? "none" : {},
            width: 150,
          }}
          label=" Search"
        />
      </Grid>
      {listData?.length > 0 && (
        <>
          <Typography
            style={{
              fontSize: 20,
              marginTop: 30,
              paddingLeft: 10,
              paddingRight: isMobile ? 0 : 10,
              color: "#171B5E",
              marginBottom: 10,
            }}
          >
            List of suggested Organization Structure
          </Typography>

          {isMobile ? (
            <Box
              container
              style={{
                backgroundColor: "#DDDDDD",
                paddingTop: 5,
                paddingBottom: 5,
              }}
              sx={{ display: "flex", justifyContent: "center", gap: "20px" }}
            >
              <Box item>
                <Typography
                  style={{
                    color: "#5E5E5E",
                    textAlign: "center",
                  }}
                >
                  Area
                </Typography>
              </Box>
              <Box sx={{ width: "20%", textAlign: "center" }}>
                <Typography style={{ color: "#5E5E5E" }}>Zone</Typography>
              </Box>
              <Box item>
                <Typography
                  style={{
                    color: "#5E5E5E",
                    textAlign: "center",
                  }}
                >
                  Member Count
                </Typography>
              </Box>
              <Box />
            </Box>
          ) : (
            <Grid
              container
              style={{
                backgroundColor: "#DDDDDD",
                paddingTop: 5,
                paddingBottom: 5,
              }}
            >
              <Grid item md={3}>
                <Typography style={{ color: "#5E5E5E", textAlign: "center" }}>
                  Area
                </Typography>
              </Grid>
              <Grid item md={4}>
                <Typography style={{ color: "#5E5E5E", marginLeft: 40 }}>
                  Zone
                </Typography>
              </Grid>
              <Grid item md={2}>
                <Typography style={{ color: "#5E5E5E", textAlign: "center" }}>
                  Member Count
                </Typography>
              </Grid>
            </Grid>
          )}
          {isMobile ? (
            <div style={{ height: 200, overflow: "auto" }}>
              {listData.map((data, i) => {
                const liStyle =
                  i % 2 === 0
                    ? { backgroundColor: "#F2F2F2", padding: 5, height: 68 }
                    : { backgroundColor: "#FFFFFF", padding: 5, height: 68 };
                return (
                  <Box
                    container
                    style={liStyle}
                    sx={{ display: "flex", gap: "20px" }}
                    alignItems="center"
                  >
                    <Grid item>
                      <Typography style={{ textAlign: "center" }}>
                        {data.areaName}
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography style={{ textAlign: "left" }}>
                        {data.zoneName}
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography style={{ textAlign: "center" }}>
                        {data.memberCount}
                      </Typography>
                    </Grid>
                    <Grid>
                      <Button
                        style={{
                          textAlign: "center",
                          width: "100px",
                        }}
                        onClick={() => {
                          handleSelectedOption(data);
                        }}
                        label="Select"
                      />
                    </Grid>
                  </Box>
                );
              })}
            </div>
          ) : (
            <div style={{ height: 200, overflow: "auto" }}>
              {listData.map((data, i) => {
                const liStyle =
                  i % 2 === 0
                    ? { backgroundColor: "#F2F2F2", padding: 5, height: 68 }
                    : { backgroundColor: "#FFFFFF", padding: 5, height: 68 };
                return (
                  <Grid container style={liStyle} alignItems="center">
                    <Grid item md={4}>
                      <Typography style={{ textAlign: "center" }}>
                        {data.areaName}
                      </Typography>
                    </Grid>
                    <Grid item md={8}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          sx={{
                            width: "30%",
                          }}
                        >
                          <Typography>{data.zoneName}</Typography>
                        </Box>

                        <Typography>{data.memberCount}</Typography>
                        <Button
                          style={{
                            textAlign: "center",
                            width: "100px",
                          }}
                          onClick={() => {
                            handleSelectedOption(data);
                          }}
                          label="Select"
                        />
                      </div>
                    </Grid>
                  </Grid>
                );
              })}
            </div>
          )}
        </>
      )}
    </Card>
  );
}

const propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleSelectedOption: PropTypes.func.isRequired,
};

ZoneLocator.propTypes = propTypes;

export default ZoneLocator;
